import React from 'react';
import { Activity, HeartPulse, ShieldCheck, Flag } from 'lucide-react';
import useInView from '../hooks/useInView';
import './ServicesSection.css';

const sections = [
  {
    icon: <Activity size={32} />,
    title: 'Sportphysiotherapie',
    items: [
      { primary: 'Betreuung von Amateur-, Hobby- und Profisportler:innen' },
      {
        primary: 'Return to Sport nach Verletzungen oder Operationen',
        secondary: 'Begleitung anhand evidenzbasierter, klar definierter Kriterien'
      },
      {
        primary: 'Interdisziplinäre Zusammenarbeit',
        secondary: 'Optimaler Therapieerfolg durch ein Netzwerk aus Partnern',
        //partners: ['FK Austria Wien', 'Medizin am Leithaberg', 'Dr. Paul Stampfl']
      }
    ]
  },
  {
    icon: <HeartPulse size={32} />,
    title: 'Rehabilitation',
    items: [
      {
        primary: 'Prä- & postoperative Physiotherapie',
        secondary: 'Optimale Vorbereitung und Unterstützung im Heilungsverlauf vor und nach Operationen.'
      },
      {
        primary: 'Akute & chronische Beschwerden des Bewegungsapparats',
        secondary: 'Gezielte Behandlung zur Schmerzlinderung und Funktionsverbesserung.'
      },
      {
        primary: 'Aktive Physiotherapie & Manuelle Therapie',
        secondary:
          'Individuelle Kombination aus aktiven Übungen und passiven Techniken zur zielgerichteten Rehabilitation.'
      }
    ]
  },
  {
    icon: <ShieldCheck size={32} />,
    title: 'Prävention',
    items: [
      {
        primary: 'Verletzungsprävention im Sport',
        secondary: 'Reduktion des Verletzungsrisikos durch Wissen, Technik und gezielte Maßnahmen.'
      },
      {
        primary: 'Athletiktraining & Gesundheitsförderung',
        secondary: 'Leistungsoptimierung auch ohne bestehende Verletzung.'
      },
      {
        primary: 'Screening & individuelle Trainingsplanung',
        secondary: 'Funktionelle Tests zur Erkennung von Defiziten und Erstellung maßgeschneiderter Trainingspläne.'
      }
    ]
  },
  {
    icon: <Flag size={32} />,
    title: 'Weiteres Angebot',
    items: [
      {
        primary: 'On-Field Rehabilitation',
        secondary:
          'Betreuung direkt am Spielfeld – ideal für den Übergang von der Therapie zurück ins Training. Profitieren Sie von meiner Erfahrung bei FK Austria Wien.'
      },
      {
        primary: 'Funktionelle Leistungschecks für Mannschaften',
        secondary: 'Auf Anfrage: Professionelle Screenings für Amateurvereine.'
      }
    ]
  }
];

const ServicesSection = () => {
  const { ref, isInView } = useInView();

  return (
    <section
      id="leistungen"
      className={`services-section reveal-section ${isInView ? 'is-visible' : ''}`}
      ref={ref}
    >
      <div className="container">
        <div className="section-header reveal-item" style={{ '--reveal-delay': '0ms' }}>
          <h2 className="heading-2">Leistungen</h2>
          <p className="body-large section-subtitle">
            Klar gegliederter Überblick über Sportphysiotherapie, Rehabilitation, Prävention und spezialisierte Angebote
          </p>
        </div>
        <div className="services-grid">
          {sections.map((service, index) => (
            <div
              key={index}
              className="service-card reveal-item"
              style={{ '--reveal-delay': `${100 + index * 80}ms` }}
            >
              <div className="service-icon">
                {service.icon}
              </div>
              <h3 className="heading-3">{service.title}</h3>
              <ul className="service-list">
                {service.items.map((item, idx) => (
                  <li key={idx} className="service-item">
                    <span className="service-item-title">{item.primary}</span>
                    {item.secondary && (
                      <span className="service-item-detail">{item.secondary}</span>
                    )}
                    {item.partners && (
                      <div className="service-partners">
                        {item.partners.map((partner) => (
                          <span key={partner} className="service-partner-chip">
                            {partner}
                          </span>
                        ))}
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
